import { render, staticRenderFns } from "./ReviewsCategoriesCompanyData.vue?vue&type=template&id=a2c50f56&scoped=true&"
import script from "./ReviewsCategoriesCompanyData.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesCompanyData.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesCompanyData.vue?vue&type=style&index=0&id=a2c50f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c50f56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
